export const diseases = {
  /* Comorbidity disease */
  obesity: 'bg-muddy',
  'heart disease': 'bg-teak',
  'renal disease': 'bg-olive',
  'mental disease': 'bg-olive-green',
  'thyroid disease': 'bg-apple',
  'neurological disease': 'bg-leaf',
  'not-set': 'color-gray',
  /* Primary disease */
  primary: 'bg-rust',
  'healthy young': 'bg-rust',
  'healthy adult': 'bg-rust',
  'healthy senior': 'bg-rust',
  'prediabetic young': 'bg-rust',
  'prediabetic adult': 'bg-rust',
  'prediabetic senior': 'bg-rust',
  'new diabetic young': 'bg-rust',
  'new diabetic adult': 'bg-rust',
  'new diabetic senior': 'bg-rust',
  'diabetic young': 'bg-rust',
  'diabetic adult': 'bg-rust',
  'diabetic senior': 'bg-rust',
  secondary: 'color-gray'
}

export const phones = {
  primary: 'primary-blue-bg',
  secondary: 'default-gray-bg'
}

export const coursesColors = {
  NEW: '#0000FF',
  'IN PROGRESS': '#FFA500',
  COMPLETED: '#008000',
  INACTIVE: '#808080'
}

export const alertsStatusColors = {
  1: '#0000FF', // NEW
  2: '#FFA500', // IN PROGRESS
  3: '#008000' // closed
}

export const alertsPriorityColors = new Map([
  [1, 'var(--yellow-alert)'],
  [2, 'var(--orange)'],
  [3, 'var(--scarlet)']
])

export const ROW_CLASS_NAME_BY_PRIORITY = new Map([
  [1, 'row-priority-low'],
  [2, 'row-priority-medium'],
  [3, 'row-priority-high']
])

export const APPOINTMENT_COLORS = [
  '#E4C441',
  '#0B8043',
  '#3F51B5',
  '#8E24AA',
  '#009688',
  '#7986CB',
  '#795548',
  '#F09300',
  '#7CB342',
  '#039BE5',
  '#B39DDB',
  '#616161',
  '#E67C73',
  '#F6BF26',
  '#33B679',
  '#4285F4',
  '#9E69AF',
  '#A79B8E',
  '#C2185B',
  '#D81B60',
  '#512DA8',
  '#1976D2',
  '#388E3C',
  '#F4511E',
  '#5D4037',
  '#00796B',
  '#455A64',
  '#C62828'
]
